import React from 'react'
import Tilt from 'react-parallax-tilt'
import { motion } from 'framer-motion'
import { images } from '../../constants'
import { Typewriter } from "react-simple-typewriter"
import './Header.scss'
import Button from '@mui/material/Button';
import SendAndArchiveIcon from '@mui/icons-material/SendAndArchive';import Stack from '@mui/material/Stack';

// BrowserUpdatedIcon
const scaleVarience={
  whileInView:{
    scale:[0,1],
    opacity:[0,1],
    transition:{
      duration:1,
      ease:'easeInOut'
    },

  },
};

const Header = () => (
    <div id='home' className='app__header app__flex'>
      <motion.div
        whileInView={{x:[-100,0],opacity:[0,1]}}
        transition={{duration:0.5}}
        className='app__header-info'
      >
        <div className="app__header-badge">
        <Tilt glareEnable={true} glareMaxOpacity={0.8} glareColor="#ffffff" glarePosition="bottom" glareBorderRadius="20px" reset={false}>
          <div className="badge-cmp app__flex">
            
            <div style={{marginLeft:20}}>
              <p className='p-text'>Hello Guys ! My Name is</p>
              <h1 className="head-text">
                Abhishek Das
              </h1>
            </div>
            
          </div>
          </Tilt>
        <div className=" apps__flex">
          <p className="m-text">
          <span>
                <Typewriter words={["Data Analyst.", " Data Visualiser.","Gamer.","Youtuber."]} loop cursor cursorStyle='|' typeSpeed={70} deleteSpeed={50} delaySpeed={1000} />
              </span>
              </p>
              
        </div>
        <Stack spacing={3} direction="row">
      <Button variant="outlined" size="large" color="success" endIcon={<SendAndArchiveIcon/>} href="https://drive.google.com/file/d/1Kc0ZknSHVfcM7T6D2ZhCUGFFUvrI3gt8/view?usp=sharing" target="_blank" >Hire Me</Button>
    </Stack>
       
    
        </div>
      </motion.div>
      <motion.div
        whileInView={{opacity:[0,1]}}
        transition={{duration:0.5,delayChildren:0.5}}
        className="app__header-img"
        >
          <img src={images.profile} alt='profile_bg'/>
          <motion.img
          whileInView={{scale:[0,1]}}
        transition={{duration:1,ease:'easeInOut'}}
        src={images.circle2}
        alt="profile_circle"
        className='overlay_circle'
        />
      </motion.div>
      
      <motion.div
        varience={scaleVarience}
        whileInView={scaleVarience.whileInView}
        className='app__header-circles'
      >
        {[images.flutter,images.react,images.java].map((circle,index)=>(
          
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt='circle'/>
          </div>
          
          
        ))}
        
      </motion.div>
      

      </div>
      
      
  )


export default Header